import styled from 'styled-components';

export const Container = styled.div`
  margin: 24px 0;
`;

export const Text = styled.p`
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 19px;
`;

export const MapContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
  background-color: ${({ bgColor }) => bgColor};
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;
